import { api } from "./api";

export const createCreditApi = (params) => {
    return api.post(`/credits/create`, JSON.stringify(params));
};

export const addRouteCreditApi = (params) => {
    return api.post(`/credits/add-credit`, JSON.stringify(params));
};

export const editRouteCreditApi = (params) => {
    return api.post(`/credits/edit`, JSON.stringify(params));
};

export const listCreditApi = (params) => {
    return api.get(`/credits/list`, { params });
};

export const viewCreditApi = (params) => {
    return api.get(`/credits/view`, { params });
};

export const routesListCreditApi = (params) => {
    return api.get(`/credits/routes`, { params });
};